export const boardCoachTour = {
  key: "boardCoach",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-coach-buckets"]',
      content: t("Tour_BoardCoach_Buckets"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-coach-mytasks"]',
      content: t("Tour_BoardCoach_MyTasks"),
      placement: "top",
    },
    {
      target: '[data-tour="board-coach-dailyplan"]',
      content: t("Tour_BoardCoach_DailyPlan"),
      placement: "right",
    },
    {
      target: '[data-tour="board-coach-aisuggestions"]',
      content: t("Tour_BoardCoach_AISuggestions"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-coach-priority"]',
      content: t("Tour_BoardCoach_Priority"),
      placement: "bottom",
    },
  ],
};
